// extracted by mini-css-extract-plugin
export default {"menu":"ProfileMenu_menu__-gxLo","avatar":"ProfileMenu_avatar__QmPBA","userInfo":"ProfileMenu_userInfo__WErFl"};